<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow :selUrl="parent"></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/column" v-if="parent==='column'">专栏课程</el-breadcrumb-item>
						<el-breadcrumb-item>专栏详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="container" v-if="detail.id">
					<div class="top">
						<div class="thumbLeft">
							<!-- <video v-if="playVideo" class="thumb" id="myVideo" :autoplay="true" :src="playVideo"
						@error="videoErrorCallback"></video> -->
							<img class="thumb" mode="aspectFill" v-if="detail.image" :src="detail.image"></img>
						</div>
						<div class="thumbRight">
							<span class="title">{{detail.name}}</span>
							<div class="infoBox" v-if="detail.show == 0">
								<div class="infoItem">
									<span v-if="detail.price*100 == 0" style="color: #ff0000">免费</span>
									<span v-else style="color: #ff0000">￥{{detail.price}}</span>
									<span>价格</span>
								</div>
								<div class="infoItem">
									<span>永久</span>
									<span>有效期</span>
								</div>
								<div class="infoItem">
									<span>{{detail.course.length}}讲</span>
									<span>总课程</span>
								</div>
								<div class="infoItem">
									<span>{{detail.study_num||0}}人</span>
									<span>已学习</span>
								</div>
								<div class="buttonBox">
									<el-button type="warning" @click="onCollect">加入收藏</el-button>
									<el-button type="danger" @click="onBooking">{{detail.price*100 == 0 ? '免费领取' : '立即订购'}}</el-button>
								</div>
							</div>
							<div class="teacherBox" v-if="detail.teacher" @click="toTeacherDetail(detail.teacher)">
								<img class="avatar" :src="detail.teacher.avatars"></img>
								<div class="name">
									<span>讲师 : {{detail.teacher.name||'*老师'}}</span>
									<span>简介 : {{detail.teacher.graduation||'--'}}</span>
								</div>
								<i class="el-icon-arrow-right"></i>
							</div>
						</div>
					</div>
					<div class="segTop" id="segTop">
						<div :class="showSegIndex === 0?'segItem segSel':'segItem'" @click="onChangeSegIndex(0)">
							<span>课程目录</span>
							<span></span>
						</div>
						<div :class="showSegIndex === 1?'segItem segSel':'segItem'" @click="onChangeSegIndex(1)">
							<span>课程介绍</span>
							<span></span>
						</div>
						<div :class="showSegIndex === 2?'segItem segSel':'segItem'" @click="onChangeSegIndex(2)">
							<span>购课须知</span>
							<span></span>
						</div>
					</div>
					<div class="segContent">
						<div v-if="showSegIndex === 0">
							<div class="catalogueList" v-if="detail.course&&detail.course.length">
								<div class="catalogueItem" v-for="item in detail.course" :key="item.course_id"
									@click="onPlayVideo(item)">
									<div class="left">
										<span>{{item.title}}</span>
										<span>{{item.study_num}}人已学习</span>
									</div>
									<div class="right">
										<img :src="item.thumb_image"> </img>
										<i v-if="item.price*100 > 0&&$store.state.auth.is_vip!=1" class="el-icon-lock"></i>
										<i v-else class="el-icon-video-play"></i>
									</div>
								</div>
							</div>
							<div class="nodata" v-else>
								<span>暂无目录</span>
							</div>
						</div>
						<div v-if="showSegIndex === 1">
							<div class="imageList" v-if="detail.detail_images">
								<div class="imageItem" v-for="img in detail.detail_images" :key="img">
									<img :src="img"></img>
								</div>
							</div>
							<div class="nodata" v-else>
								<span>暂无介绍</span>
							</div>
						</div>
						<div v-if="showSegIndex === 2">
							<div class="guideList" v-if="guide&&guide.length">
								<div class="guideItem" v-for="one in guide" :key="one.id">
									<div>
										<i class="el-icon-question"></i>
										<span>{{one.title}}</span>
									</div>
									<div v-html="one.content"></div>
								</div>
							</div>
							<div class="nodata" v-else>
								<span>暂无须知</span>
							</div>
						</div>
					</div>
					<div :class="showFix?'fixCourse fixShow':'fixCourse'" v-if="showFix">
						<img class="thumb" mode="aspectFill" v-if="detail.image" :src="detail.image">
						</img>
						<span class="title">{{detail.name}}</span>
						<span class="price" v-if="detail.price*100 == 0" style="color: #ff0000">免费</span>
						<span class="price" v-else style="color: #ff0000">￥{{detail.price}}</span>
						<div class="buttonBox">
							<el-button type="warning" @click="onCollect">加入收藏</el-button>
							<el-button type="danger" @click="onBooking">{{detail.price*100 == 0 ? '免费领取' : '立即订购'}}</el-button>
						</div>
					</div>
				</div>
			</el-main>
		</el-container>
		<CashierDialog ref="cashierRef" />
		<TeacherDialog ref="teacherRef" />
		<TellBindDialog ref="tellBindRef" @onSuccess="onBindSuccess" />
	</div>
</template>

<script>
	import indexjs from "./";
	import {
		copy
	} from "clipboard";
	import FooterRow from "@/components/footerRow.vue";
	import LoginDialog from "@/components/loginDialog.vue";
	import HeaderRow from "@/components/headerRow.vue";
	import CashierDialog from "@/components/cashierDialog.vue";
	import TeacherDialog from "@/components/teacherDialog.vue";
	import TellBindDialog from "@/components/tellBindDialog.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
			LoginDialog,
			CashierDialog,
			TeacherDialog,
			TellBindDialog
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "index";
</style>